import { GOOGLE_FONTS, useGoogleFonts } from '~/client/common/hooks/use-google-fonts.hook'
import { EventSpaceList } from '~/shared/event/event.types'
import React from 'react'
import BackgroundPattern from '~/client/components/present/WP2Template/assets/coverBackground.png'
import { formatUtcDateLongFromUnknown } from '~/shared/common/date'

// Placeholder for logo - user will add later
// import wp2Logo from '~/Images/custom-wp2-logo.svg'

const Container: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="bg-[#003A5D] w-[1920px] h-[1080px] min-w-[1920px] min-h-[1080px] max-w-[1920px] max-h-[1080px] p-0 m-0 relative overflow-hidden flex flex-col">{children}</div>
)

interface WP2SlideCoverProps {
  eventSpaceList: EventSpaceList
  coverImage?: string | null
}

const WP2SlideCover: React.FC<WP2SlideCoverProps> = ({ eventSpaceList }) => {
  useGoogleFonts([GOOGLE_FONTS.INTER])

  // Get the first event date if available
  const eventDate = formatUtcDateLongFromUnknown(eventSpaceList.event_space_list_dates?.[0]?.start_date, 'en-US') ?? ''

  return (
    <Container>
      {/* Geometric Pattern Background */}
      <img src={BackgroundPattern} alt="Background Pattern" className="absolute inset-0 w-full h-full" />

      {/* Main Content */}
      <div className="relative z-10 flex flex-col justify-center h-full px-[154px]">
        {/* Event Name */}
        <div className="max-w-[800px] mb-[80px] text-start">
          <h1 className="font-['Inter',sans-serif] text-[96px] leading-[90px] font-bold text-white">{eventSpaceList.name || ''}</h1>
        </div>

        {/* VENUE OPTIONS */}
        <div className="mb-[24px] text-start">
          <div className="font-['Inter',sans-serif] text-[36px] font-semibold text-white tracking-[2px] text-start">VENUE OPTIONS</div>
        </div>

        {/* Date */}
        {eventDate && (
          <div className="text-start">
            <div className="font-['Inter',sans-serif] text-[28px] font-normal text-white">{eventDate}</div>
          </div>
        )}
      </div>
    </Container>
  )
}

export default WP2SlideCover
